import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function WorkBadgePreviewError() {
  return (
    <Stack
      spacing={4}
      alignItems="center"
      sx={(theme) => ({
        border: `1px solid ${theme.palette.error.main}`,
        padding: theme.spacing(4),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
      })}
    >
      <Title component="h4">Failed to load badge preview</Title>
      <Text variant="body1">
        Please try again. If the problem persists, please contact support.
      </Text>
    </Stack>
  );
}
